import { getBackendUrls } from "@/config/getBackendUrls";
import { getSelectedSessionId } from "@/sdk";
import { getSharedApiClient } from "@/shared-utils";

export function getChatMetadataApiClient() {
    return getSharedApiClient(getSelectedSessionId()).extend(() => ({
        prefix: `${getBackendUrls().apiBaseUrl}/api/chat-metadata`,
    }));
}
